import { jsx as _jsx } from "react/jsx-runtime";
/**
 * ContentButton component that renders a button with customizable styles and behaviors.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Optional additional class names for the button.
 * @param {function} props.onClick - Callback function to handle button click.
 * @param {React.ReactNode} props.children - Content to be displayed inside the button.
 * @param {boolean} props.isSelected - Flag to indicate if the button is in a selected state.
 * @param {React.CSSProperties} [props.style] - Optional inline styles for the button.
 * @param {boolean} [props.hideOverflow=true] - Flag to hide overflow content. Set to false if you want to use tool tips or anything that sould flow out of the button.
 * @returns {JSX.Element} The rendered button component.
 */
export function ContentButton({ className, onClick, children, isSelected, style, hideOverflow = true, }) {
    return (_jsx("button", { onClick: onClick, type: "button", className: `${className} ${hideOverflow ? 'overflow-hidden' : undefined} hover:border-sourgum-green-500 flex cursor-pointer rounded-lg border shadow hover:shadow-none`, style: {
            boxShadow: isSelected ? 'none' : undefined,
            backgroundColor: isSelected ? 'var(--dumpster-glow-500)' : undefined,
            transition: 'background-color 300ms ease-in-out, box-shadow 300ms ease-in-out, border-color 400ms ease-in-out',
            ...style,
        }, children: children }));
}
//# sourceMappingURL=content-button.js.map